module.exports = __webpack_public_path__ + "media/icons/salonowy-active@2x-9d6c6cdb.png";